import { useTranslation } from 'react-i18next'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { EARN_DASHBOARD_STATE } from '../../types'
import { EarnEmbeddedDashboardData, UseEarnPageDataHandlers } from '../../types/dashboardState'
import {
  formatWholePercentage,
  toEarnCustomerAmountsView,
  toEarnTotalEarningsView,
} from '../../utils/utils'
import { useEarnDashboardBaseData } from './useEarnDashboardBaseData'

export const useEarnEmbeddedDashboardData = (
  handlers: UseEarnPageDataHandlers
): EarnEmbeddedDashboardData => {
  const { t } = useTranslation()
  const canManageDistribution = !!useMappedRoles()?.earn?.canDistribute
  const baseData = useEarnDashboardBaseData(handlers)

  if (baseData.dashboardState !== EARN_DASHBOARD_STATE.READY) {
    return baseData
  }

  const { dashboard, statistics, assets, isStatisticsLoading, summary } = baseData

  const activeEarnAsset = dashboard.earnAssets[0]
  const merchantStatistics = activeEarnAsset
    ? statistics?.currencies[activeEarnAsset.asset]
    : undefined

  return {
    dashboardState: EARN_DASHBOARD_STATE.READY,
    assets,
    epcTakesEarn: activeEarnAsset?.epcTakesEarn ?? false,
    distributionProductId: activeEarnAsset?.productId ?? undefined,
    canManageDistribution,
    isStatisticsLoading,
    summary,
    totalEarnings: toEarnTotalEarningsView(dashboard.totalEarnings),
    customerRewardsProgram: {
      optInRateLabel: t('earn.optInRateLabel', {
        rate: formatWholePercentage(merchantStatistics?.optIn.rate ?? 0),
        count: merchantStatistics?.optIn.optedInCustomers ?? 0,
      }),
      ...toEarnCustomerAmountsView(merchantStatistics),
    },
  }
}
